import { useState, useEffect, useCallback } from 'react'
import { useRouter } from 'next/router'
import { NextSeo } from 'next-seo'
import { useDispatch } from '~/lib/hooks/redux'
import axios from '~/lib/axios'
import { UserData } from '~/types'
import { UserTermsPageDataApiResponse } from '~/types/api'
import styled from 'styled-components'
import DefaultPageLayout from '~/components/templates/DefaultPageLayout'
import Header from '~/components/molecules/Modal/Header'

export default function UserTermsPage() {
  const router = useRouter()
  const userId = router.query.user_id !== undefined ? `${router.query.user_id}` : undefined
  const [userData, setUserData] = useState<UserData | undefined>()
  const dispatch = useDispatch()

  const fetch = useCallback(async () => {
    const res = await axios<UserTermsPageDataApiResponse>(
      {
        url: `/users/terms/${encodeURI(`${userId}`)}`
      },
      { dispatch }
    )
    if (res !== undefined) {
      setUserData(res.user)
    }
  }, [userId])

  useEffect(() => {
    if (userId !== undefined) {
      fetch()
    }
  }, [userId])

  const handleClose = useCallback(() => {
    router.push(`/users/${userId}`)
  }, [router])

  return (
    <DefaultPageLayout>
      <NextSeo
        title='特定商取引法に基づく表記'
        openGraph={{
          url: `${process.env.origin}/users/${encodeURI(`${userId}`)}/terms`,
          title: '特定商取引法に基づく表記 - Ambass'
        }}
      />
      <StyledHeader title='特定商取引法に基づく表記' onClose={handleClose} />
      <Container>
        <Row>
          <Head>クリエイター名</Head>
          {userData && <Detail>{userData.name}</Detail>}
        </Row>
        <Row>
          <Head>事業者の名称・連絡先</Head>
          <Detail>省略した記載については、電子メール等の請求により遅滞なく開示いたします。</Detail>
        </Row>
        <Row>
          <Head>販売価格</Head>
          <Detail>販売価格は消費税を含む価格で表示されています。</Detail>
        </Row>
        <Row>
          <Head>代金の支払方法</Head>
          <Detail>クレジットカード</Detail>
        </Row>
        <Row>
          <Head>代金の支払時期</Head>
          <Detail>クレジットカード: 商品注文時点でお支払いが確定します。</Detail>
        </Row>
        <Row>
          <Head>返品等についての特約に関する事項</Head>
          <Detail>商品に欠陥があり、当Ambassが認める場合を除き、返品には応じません。</Detail>
        </Row>
      </Container>
    </DefaultPageLayout>
  )
}

const StyledHeader = styled(Header)`
  margin: 24px -8px 48px;
`
const Container = styled.div`
  display: grid;
  grid-gap: 24px;
`
const Row = styled.div``
const Head = styled.div`
  ${({ theme }) => theme.fonts.Bold14};
  color: ${({ theme }) => theme.colors.OnSurface5};
`
const Detail = styled.div`
  ${({ theme }) => theme.fonts.Bold16};
  color: ${({ theme }) => theme.colors.OnSurface2};
`
